import { render, staticRenderFns } from "./index-v2.vue?vue&type=template&id=16ca116a&"
import script from "./index-v2.vue?vue&type=script&lang=js&"
export * from "./index-v2.vue?vue&type=script&lang=js&"
import style0 from "./index-v2.vue?vue&type=style&index=0&id=16ca116a&prod&lang=css&"
import style1 from "./index-v2.vue?vue&type=style&index=1&id=16ca116a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports